import { IStaffDrivenData, IStaffDrivenToDo } from '../staff_todo_interface';
import { IStrategySafe, StrategySafe } from 'utility-ts-strategy';
import { StaffTodoListQuery } from '../queries/staff_todo_list_query';
import * as _4 from 'lodash4';

export class StaffTodoFilterServant {
  private strategy: IStrategySafe<any, string>;

  constructor(private ngStaffTodoListQuery: StaffTodoListQuery) {
    this.strategy = new StrategySafe<any, string>({
      upcomingStaffTodos: this.upcomingStaffTodos,
      staffTodosForToday: this.staffTodosForToday,
      completedStaffTodos: this.completedStaffTodos,
      overdueStaffTodos: this.overdueStaffTodos
    });
  }

  get filterStrategy(): IStrategySafe<any, string> {
    return this.strategy;
  }

  upcomingStaffTodos(): IStaffDrivenToDo[] {
    const todos = _4.filter(this.ngStaffTodoListQuery.result, (todo: IStaffDrivenData) => {
      return _4.isEmpty(todo.cleared_date) && moment(todo.due_date || '').isAfter(moment(), 'day');
    });

    return _4.map(todos, (todo: IStaffDrivenData) => {
      return { task: todo };
    });
  }

  staffTodosForToday(): IStaffDrivenToDo[] {
    const todos = _4.filter(this.ngStaffTodoListQuery.result, (todo: IStaffDrivenData) => {
      return _4.isEmpty(todo.cleared_date) && moment(todo.due_date || '').isSame(moment(), 'day');
    });

    return _4.map(todos, (todo: IStaffDrivenData) => {
      return { task: todo };
    });
  }

  completedStaffTodos(): IStaffDrivenToDo[] {
    const todos = _4.filter(this.ngStaffTodoListQuery.result, (todo: IStaffDrivenData) => {
      return !_4.isEmpty(todo.cleared_date);
    });

    return _4.map(todos, (todo: IStaffDrivenData) => ({
      task: todo
    }));
  }

  overdueStaffTodos(): IStaffDrivenToDo[] {
    const todos = _4.filter(this.ngStaffTodoListQuery.result, (todo: IStaffDrivenData) => {
      return _4.isEmpty(todo.cleared_date) && moment(todo.due_date || '').isBefore(moment(), 'day');
    });

    return _4.map(todos, (todo: IStaffDrivenData) => ({
      task: todo
    }));
  }
}

angular.module('data-ng-staff-todos').service('ngStaffTodoFilterServant', StaffTodoFilterServant);



// WEBPACK FOOTER //
// ./app/vendor/data-ng-staff-todos/src/services/staff_todo_filter_servant.ts